module.exports = __webpack_public_path__ + "7817bd2e6850552f66b15b9653e44285.svg";